import {
  AnonymityInfo,
  ConfirmEmail,
  DescriptionInfo,
  DeviceTypeInfo,
  IndustryInfo,
  InviteLCInfo,
  LCEmailInfo,
  LocationInfo,
  ProjectNameInfo,
  Skip1Info,
  Skip2Info,
  SkipActivitiesInfo,
  SkipLCInfo,
} from "../Reuseables/InfoMessages";

const formModel = {
  formId: "projectForm",
  formField: {
    tenantName: {
      name: "tenantName",
    },
    projectName: {
      name: "projectName",
      label: "labels.projectName",
      placeholder: "placeholders.projectName",
      infoMsg: <ProjectNameInfo />,
    },
    description: {
      name: "description",
      label: "labels.description",
      placeholder: "placeholders.description",
      infoMsg: <DescriptionInfo />,
    },
    industry: {
      name: "industry",
      label: "labels.industry",
      infoMsg: <IndustryInfo />,
    },
    location: {
      name: "location",
      label: "labels.location",
      placeholder: "placeholders.location",
      infoMsg: <LocationInfo />,
    },
    storageRegion: {
      name: "storageRegion",
    },
    anonymity: {
      name: "anonymity",
      label: "labels.anonymity",
      infoMsg: <AnonymityInfo />,
    },
    deviceType: {
      name: "deviceType",
      label: "labels.deviceType",
      infoMsg: <DeviceTypeInfo />,
    },
    skipLocalCoordinator: {
      name: "skipLocalCoordinator",
      skipLocalCoordinator: <SkipLCInfo />,
      inviteLocalCoordinator: <InviteLCInfo />,
    },
    localCoordinatorEmail: {
      name: "localCoordinatorEmail",
      label: "labels.localCoordinator",
      placeholder: "placeholders.email",
      infoMsg: <LCEmailInfo />,
    },
    confirmEmail: {
      name: "confirmEmail",
      label: "labels.confirmEmail",
      placeholder: "placeholders.email",
      infoMsg: <ConfirmEmail />,
    },
    activities: {
      name: "activities",
      label: "labels.activity",
      placeholder: "placeholders.activity",
    },
    skipActivities: {
      name: "skipActivities",
      label1: "buttons.fillInLater",
      label2: "buttons.leaveRestForLater",
      label3: "buttons.leaveForLC",
      label4: "buttons.leaveRestForLC",
      infoMsg1: <Skip1Info />,
      infoMsg2: <Skip2Info />,
      infoMsg3: <SkipActivitiesInfo />,
    },
    readyForReview: {
      name: "readyForReview",
    },
  },
};

export default formModel;
